module.exports = __webpack_public_path__ + "static/media/Ice Fisherman.8fae00b6.jpg";